module.exports = __webpack_public_path__ + "img/13.393fb283.jpg";